import {
  AuthStateDocument,
  SiteUser_RegisterInput,
  useRegisterUserMutation
} from 'generated/graphql';
import { appFormUtil } from 'modules';
import React from 'react';
import { IInitialRegisterationOFormState } from './types';



const initialState: IFormState = {
  agreedToTermsChecked: false,
  email: '',
  password: '',
  confirmPassword: '',
  inviteCode: '',
  confirmationCode: '',
  firstName: '',
  lastName: '',
  confirmationModalVisible: false
};

// export type IFormState = typeof initialState;
export type IFormState = IInitialRegisterationOFormState;


export function useQuery({ inviteCode }: { inviteCode: string }) {
  const {
    formState,
    genFieldProps,
    dispatch
  } = appFormUtil.useFormState<IFormState>({
    initialState: {
      ...initialState,
      inviteCode
    },
    key2FieldConfig: {
      email: {
        label: 'Email',
        type: 'email',
        required: true,
        fnValidate: (e) => {
          if (typeof e === 'string') {
            if (e.length < 2) {
              return '';
            }
            if (e.length > 4 && e.includes('@')) {
              return '';
            } else {
              return 'Please enter valid email';
            }
          } else {
            return '';
          }
        }

      },
      password: {
        label: 'Password',
        type: 'password'
      },
      confirmPassword: {
        label: 'Confirm Password',
        type: 'password',
        required: true,
        fnValidate: (e) => {
          if (typeof e !== 'string') {
            return '';
          }
          if (e.length < 8) {
            return '';
          }
          if (e !== formState.password) {
            return 'Passwords do not match';
          } else {
            return '';
          }
        }
      },
      firstName: {
        label: 'First Name',
        type: 'text'
      },
      lastName: {
        label: 'Last Name',
        type: 'text'
      },
      confirmationCode: {
        label: 'Confirmation Code',
        type: 'text'
      },
      inviteCode: {
        label: '',
        type: 'text'
      }
    }
  });

  return React.useMemo(
    () => {


      return {
        formState,
        genFieldProps,
        dispatch
      };
    },
    [
      formState,
      genFieldProps,
      dispatch
    ]
  );
}


export function useRegisterUser() {
  const [
    fnMutate,
    tuple
  ] = useRegisterUserMutation({
    // Will trigger the read fields to re-run
    refetchQueries: [{
      query: AuthStateDocument
    }]
  });

  const fnWrappedMutate = React.useCallback(
    async (input: SiteUser_RegisterInput) => {
      await fnMutate({
        variables: {
          input: {
            ...input
          }
        }
      });
    },
    [fnMutate]
  );

  return React.useMemo(
    () => [
      fnWrappedMutate,
      {
        ...tuple,
        data: null
      }
    ] as const,
    [
      fnWrappedMutate,
      tuple
    ]
  );
}
